module.exports = "/_next/static/images/d209cda7807373024be01bde2e346700-mgm-invite-ticket-5.jpg.webp";